/**
 * Sum all the elements of a list and return the total.
 *
 * @param values Values to be sum.
 * @returns Returns the interpolated value.
 * @example
 *
 * sum(1, 2, 3, 4)
 * // => 10
 *
 * sum(...[1, 2, 3, 4, 5])
 * // => 15
 *
 * sum(-1, 2, 3, -4)
 * // => 0
 */
export function sum(...values: number[]): number {
  return values.reduce((p: number, c: number) => p + c, 0);
}
